// extracted by mini-css-extract-plugin
export default {"Value":"PayCardsList_Value__FRM8r"};